import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { spacing, colors, subtleShadow } from 'ui/theme';

const RADIO_STYLES: Record<string, FlattenSimpleInterpolation> = {
  default: css`
    :hover {
      border-color: ${colors.grey50};
    }
  `,
  disabled: css`
    background: ${colors.grey1};
    color: ${colors.textDisabled};
  `,
  selected: css`
    border: ${spacing.single} solid ${colors.green50};
    outline: ${spacing.single} solid ${colors.green50};
  `,
  disabledAndSelected: css`
    background: ${colors.grey10};
    border: ${spacing.single} solid ${colors.grey35};
  `,
};

export const getBorderedRadioStyles = (isDisabled = false, isChecked = false) => {
  if (isDisabled && isChecked) return RADIO_STYLES.disabledAndSelected;
  else if (isDisabled) return RADIO_STYLES.disabled;
  else if (isChecked) return RADIO_STYLES.selected;
  else return RADIO_STYLES.default;
};

export const TileRadioWrapper = styled.div<{
  isChecked?: boolean;
  isDisabled: boolean;
  isVertical: boolean;
}>`
  display: flex;
  align-items: center;
  padding: ${spacing.base};
  border: ${spacing.single} solid ${colors.grey15};
  border-radius: ${spacing.half};
  box-shadow: ${subtleShadow.boxShadow};
  background: ${colors.white};
  color: ${colors.black};
  cursor: pointer;
  ${({ isVertical }) =>
    isVertical
      ? css`
          flex-direction: column;
        `
      : css`
          gap: ${spacing.half};
        `}
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      cursor: not-allowed;
    `}

  ${({ isDisabled, isChecked }) => getBorderedRadioStyles(isDisabled, isChecked)}
`;

export const RadioIcon = styled.div<{ isVertical: boolean }>`
  ${({ isVertical }) =>
    isVertical &&
    css`
      align-self: flex-start;
      margin: -${spacing.half};
      margin-bottom: 0;
    `}
`;
